import React, {
  RefObject,
  useState,
} from 'react';
import classnames from 'classnames';
import { useScrollPosition } from '../../hooks/useScrollPosition';
import { scrollToTopOfPage } from '../../utils/scrollToTopOfPage';
import { BackArrowIcon } from '../../icons';

import styles from './BackToTop.module.scss';

enum UsersKind {
  'user' = 'user',
  'admin' = 'admin',
}

interface BackToTopType {
  type: keyof typeof UsersKind
  label: string
  element?: RefObject<Element> | null
}

function BackToTop({
  type,
  label,
  element = null,
}: BackToTopType): JSX.Element {
  const [showOnScroll, setShowOnScroll] = useState(false);

  useScrollPosition(({ currPos }) => {
    const isShow = currPos.y < 0;
    if (isShow !== showOnScroll) {
      setShowOnScroll(isShow);
    }
  }, element);

  return (
    <>
      {showOnScroll && (
        <button
          type="button"
          className={classnames(styles.backToTop, {
            [styles[type]]: type,
          })}
          onClick={scrollToTopOfPage}
        >
          <BackArrowIcon
            className={styles.arrowUp}
          />
          <p className={styles.labelButton}>
            {label}
          </p>
        </button>
      )}
    </>
  );
}

export default BackToTop;
